import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=e1890904&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=js"
export * from "./ModalProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&id=e1890904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1890904",
  null
  
)

export default component.exports